import { StyleSheet, View } from "react-native";
import { FeedbackInbox } from "@jackedlogs/ui";
import { apiFetch } from "./api";

// Admin feedback inbox surface, rendered from the shared @jackedlogs/ui
// component (same RN tree that mounts on mobile). The header + sign-out
// + admin route-gating live in AppShell now; this is body-only. The nav
// tab already names this surface, so showTitle={false} (the count pill
// still renders) — no double title.
export function InboxScreen({ dark }: { dark: boolean }) {
  return (
    <View style={styles.body}>
      <FeedbackInbox apiFetch={apiFetch} dark={dark} showTitle={false} />
    </View>
  );
}

const styles = StyleSheet.create({
  body: { flex: 1 },
});
